import styled from "styled-components"

// Checkmark
export const CheckMark = <svg viewBox="0 0 24 24" width="24" height="24" focusable="false"><path fill="currentColor" d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"></path></svg>

// Exclamation Mark
export const ExclamationMark = <svg viewBox="0 0 24 24" width="24" height="24" focusable="false"><path fill="currentColor" d="M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"></path></svg>

// Info Mark
export const InfoMark = <svg viewBox="0 0 24 24" width="24" height="24" focusable="false"><path fill="currentColor" d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"></path></svg>

export const IconWrapper = styled.span`
    display: inline-flex;
    width: ${(props) => props.$size? props.$size : '1.5rem'};
    height: ${(props) => props.$size? props.$size : '1.5rem'};
    //max-width: '3rem';
    //max-height: '3rem';
    margin-right: 0.5rem;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;

    & > svg {
        width: 100%;
        height: 100%;
        display: block;
    }
`